<template>
  <div>
    <h3>About Me :</h3>
    <p>
      Hello I am 21 years old and eversince i can remeber i was in love with
      computer and technology.
    </p>
    <p>
      So When i reached 20 i started learning Python on one of the youtube
      channels i found at the time.
    </p>
    <p>
      When i finally undrestood what programming is i decided to start my career
      as a FRONT-END developer.
    </p>
    <p>
      I started out with React but as i experinced working with it i decided to
      learn VUE and i am Happy About it.
    </p>
  </div>
</template>

<script>
export default {
  name: "YAbout",
};
</script>

<style scoped>
h3 {
  color: yellow;
}
p {
  font-size: 16px;
  margin: 10px 0px;
}
</style>
